import { isArray } from 'util';
import { MaintenanceTaskConfigurationFile } from '../maintenance-task-configuration-file';
import { UserBuilder } from './user.builder';

export class MaintenanceTaskConfigurationFileBuilder {
  static fromJson(json) {
    return (json)
      ? new MaintenanceTaskConfigurationFile(
        json.hash,
        json.fileName,
        json.filePath,
        json.fileMimeType,
        UserBuilder.fromJson(json.user),
        json.date
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(MaintenanceTaskConfigurationFileBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/maintenance-task-configuration-file.builder.ts